import React, { useState } from "react";
import "./CustomMessageList.css";
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SyncIcon from "@mui/icons-material/Sync";
import { useDispatch, useSelector } from "react-redux";
import { percentRanges } from "../../constants/percentRanges";
import Locale from "../../locales";
import { fetchCustomMessages, removeRandomMessage } from "../../redux/actions";

const useStyles = makeStyles({
  selectStudentControl: {
    width: "100%",
  },
  syncBuuton: {
    marginRight: "25px",
  },
});

const CustomMessageList = () => {
  const loading = useSelector((state) => state.adminReducer.loading);
  const messages = useSelector((state) => state.adminReducer.messages);
  const [range, setRange] = useState("");
  const styles = useStyles();
  const dispatch = useDispatch();

  const handleRangeChange = (event) => {
    setRange(event.target.value);
    const ranges = event.target.value.split("-");
    const fromRange = +ranges[0];
    const toRange = +ranges[1];
    dispatch(fetchCustomMessages(fromRange, toRange));
  };

  const removeMessageButtonHandler = (referenceId) => {
    dispatch(removeRandomMessage(referenceId));
  };

  const handleRefreshButtonClick = () => {
    if (range === "") {
      return;
    }
    const ranges = range.split("-");
    const fromRange = +ranges[0];
    const toRange = +ranges[1];
    dispatch(fetchCustomMessages(fromRange, toRange));
  };

  return (
    <div className="message-list-container">
      <div className="message-list-heading-container">
        <h1 className="message-list-header-text">
          {Locale.t("manage_current_available_messages")}
        </h1>
        <Tooltip title={Locale.t("refresh")}>
          <IconButton
            onClick={handleRefreshButtonClick}
            className={styles.syncBuuton}>
            <SyncIcon fontSize="large" color="info" />
          </IconButton>
        </Tooltip>
      </div>
      <div className="message-list-section-container">
        <FormControl disabled={loading} className={styles.selectStudentControl}>
          <InputLabel id="select-range">
            {Locale.t("select_range_whose_messages_you_want_to_view")}
          </InputLabel>
          <Select
            labelId="select-range-label"
            id="select-range"
            value={range}
            label={Locale.t("select_range_whose_messages_you_want_to_view")}
            onChange={handleRangeChange}>
            {percentRanges.map((percentRange) => (
              <MenuItem key={percentRange} value={percentRange}>
                {percentRange}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="section-container message-list-main-section">
        {messages.length !== 0 &&
          messages.map((message) => (
            <div className="message-list-item" key={message.referenceId}>
              <div className="percentage">
                <h2>{message.percentage}%</h2>
              </div>
              <div className="message-container">
                <h2>{message.message}</h2>
              </div>
              <div>
                <Button
                  onClick={() =>
                    removeMessageButtonHandler(message.referenceId)
                  }
                  variant="contained"
                  color="error">
                  {Locale.t("remove")}
                </Button>
              </div>
            </div>
          ))}
        {messages.length === 0 && (
          <div className="message-list-item empty-message-list-item">
            <h1>{Locale.t("no_messages")}</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomMessageList;
